import React from "react";

function General() {
  return (
    <div className="general">
      <h2>Hi, I'm Will Riffe— and this is my web app.</h2>
      <h2>
        Coding is one of my more recently aquired skills, and I hope this
        portfolio site conveys how much I'm enjoying it! If you're here, then
        you're probably aware that I am also open to work in software
        development. Currently, I work in a laboratory setting, and I have a
        background in geology.
      </h2>
      <h2>
        I met someone who is quite competent with technology, and she inspired
        me to learn how to code. Over the past year, I've honed my skills in
        languages like HTML, CSS, and JavaScript, even completing the Rutgers
        Full Stack Coding Bootcamp through EdX to learn how to tackle projects
        professionally and adapt to new technologies swiftly.
      </h2>
      <h2>
        Not only am I enthusiastic to keep developing this skill, which I find
        challenging, and mentally stimulating; I am also willing to switch
        careers in order to do so. I have found that much of the work in geology
        and environmental science lacks a certain dynamism, and isn't so
        challenging when you get right down to it. software development, on the
        other hand, is actually a fresh field which is always changing, and I
        would like to dive right into it!
      </h2>
    </div>
  );
}
export default General;
